<template>
  <header v-if="home" id="navbar" class="custom-header" v-scroll="handleScroll">
    <nav class="nav">
      <div :style="linkWrapperStyles.left" class="wrapper-box" ref="leftLink">
        <div class="link-wrapper">
          <a :style="{ fontSize }" href="https://blog.mrinalini.dev/">
            Blog
          </a>
        </div>
      </div>
      <div class="wrapper-box" :style="linkWrapperStyles.right" ref="rightLink">
        <div class="link-wrapper">
          <a :style="{ fontSize }" href="https://resume.mrinalini.dev/">
            Resume
          </a>
        </div>
      </div>
    </nav>
  </header>
  <header v-else class="router-links-header">
    <router-link to="/">
      <img class="logo" src="@/assets/logo.svg" alt="" />
    </router-link>
  </header>
</template>

<script>
  import { getSlope, getX } from '@/utils/'
  import { mapState } from 'vuex'

  export default {
    name: 'Navbar',
    data() {
      return {
        scrollPos: 0,
        slope: 0,
        scrollDistance: 0,
        intercept: 0,
        maxX: 0,
        x: 0,
        width: 0,
        initialDistance: { left: 0, right: 0 }
      }
    },
    props: {
      home: { default: true, required: false, type: Boolean }
    },
    watch: {
      scrollDistance(y) {
        if (y < this.intercept) {
          const m = this.slope,
            b = this.intercept

          const x = getX({ y, m, b })

          this.x = x
        }
      },
      windowSize() {
        this.getInitialMeasurements()
      }
    },
    computed: {
      ...mapState(['windowSize']),

      opacity() {
        const opacity =
          this.scrollPos === 1
            ? 1 - this.$store.state.scrollPos
            : this.scrollPos + 0.3
        return opacity
      },

      fontSize() {
        const size =
          this.scrollPos === 1
            ? Math.abs(1 - this.$store.state.scrollPos * 2)
            : 2
        return Math.max(size, 1) + 'rem'
      },

      leftLinkStyle() {
        const { left } = this.initialDistance,
          { leftLink } = this.$refs,
          leftWidth = leftLink ? leftLink.clientWidth : 128,
          leftDist = left - leftWidth,
          newStyles = { left: leftDist + 'px' }

        if (this.scrollDistance < this.intercept) {
          newStyles.left =
            Math.max(
              0,
              Math.min(leftDist, Math.min(left - Math.abs(this.x), left))
            ) + 'px'
        }

        return newStyles
      },

      rightLinkStyle() {
        const { right } = this.initialDistance,
          { rightLink } = this.$refs,
          rightWidth = rightLink ? rightLink.clientWidth : 138,
          rightDist = right - rightWidth,
          newStyles = { left: right + 'px' }

        if (this.scrollDistance < this.intercept) {
          newStyles.left =
            Math.min(
              this.width,
              Math.max(right, rightDist + Math.abs(this.x))
            ) + 'px'
        }

        return newStyles
      },

      linkWrapperStyles() {
        const common = {
          backgroundColor: `rgba(9, 9, 9, ${this.opacity})`
        }
        const right = { ...common, ...this.rightLinkStyle },
          left = { ...common, ...this.leftLinkStyle }
        return { right, left }
      }
    },

    methods: {
      handleScroll(evt, el) {
        const top = el.getBoundingClientRect().top,
          pos = top / el.offsetTop

        this.scrollDistance = top
        this.scrollPos = Math.min(1 - pos, 1)
      },
      getInitialMeasurements() {
        const { width, height } = this.windowSize,
          /* Change these numbers to make elements move different distance. Calculated with y = mx + b formula */
          maxX = width * (5 / 12), // 1/3 is too far
          halfHeight = height / 2 //y

        const x = [-1 * maxX, 0],
          y = [0, halfHeight]

        const slope = getSlope({ x, y })
        this.width = width
        this.intercept = halfHeight //b
        this.slope = slope //m
        this.maxX = maxX //x

        this.initialDistance = {
          right: (7 / 12) * width,
          left: (5 / 12) * width
        }
      }
    },
    mounted() {
      this.getInitialMeasurements()
    }
  }
</script>

<style lang="scss">
  .custom-header {
    overflow: hidden;
    position: sticky;
    top: -1rem;
    left: 0;
    min-width: 100vw;
    height: 5rem;
    margin-bottom: 25vh;
    z-index: 10;
    align-self: flex-start;
    width: 100vw;
  }

  .nav {
    width: 100vw;
    padding: 0 2rem;
    position: relative;
    .wrapper-box {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 8rem;
      min-height: 3.5rem;
      position: absolute;
      top: 0.25rem;
      @include small-breakpoint {
        min-width: 10rem;
      }

      &:after {
        content: '';
        display: block;
        padding-bottom: 40%;
      }
      .link-wrapper {
        // flex-basis: 100%;
        a {
          display: flex;
          align-items: center;
          text-align: center;
          margin: 0;
          padding: 0 0.75rem;

          @include underline-on-hover($link-color);
        }
      }
    }
  }

  .router-links-header {
    position: fixed;
    z-index: 10;
    padding: 2rem;
    left: 0;
    .logo {
      height: 30px;
    }
  }
</style>
